import React, { useRef } from "react";
import { IErrors } from "../../interfaces/status";

import { errorsConfig } from "../../config/errors";

import { Form as FormStyled } from "./styles";

export interface IForm extends React.FormHTMLAttributes<HTMLFormElement> {}

export const Form: React.FC<IForm> = ({
  children,
  noValidate,
  onSubmit,
  ...props
}) => {
  const formRef = useRef(null);

  const setErrorInputDate = (message: string, input: HTMLElement) => {
    input.classList.add("error");
    const inputWrapperEl = input.parentElement?.parentElement?.parentElement;

    const { name } = input as HTMLInputElement;

    const infoEl = inputWrapperEl?.querySelector(`.input-info.${name}`);

    infoEl?.classList.add("error");
    infoEl!.innerHTML = message;
  };

  const setErrorInputPassword = (message: string, input: HTMLElement) => {
    const inputEl = input.parentElement!;
    inputEl.classList.add("error");

    const inputWrapperEl = inputEl.parentElement;
    const infoEl = inputWrapperEl?.querySelector(`.input-info`);

    infoEl?.classList.add("error");
    infoEl!.innerHTML = message;
  };

  const setErrorInputCheckbox = (message: string, input: HTMLElement) => {
    const inputEl = input.parentElement!;
    inputEl.classList.add("error");

    const inputContainerEl = inputEl.parentElement?.parentElement;
    const infoEl = inputContainerEl?.querySelector(`.input-info`);
    infoEl?.classList.add("error");
    infoEl!.innerHTML = message;
  };

  const setErrorInputSearch = (message: string, input: HTMLElement) => {
    const inputEl = input.parentElement!;

    inputEl.classList.add("error");

    const inputContainerEl = inputEl.parentElement;
    const infoEl = inputContainerEl?.querySelector(`.input-info`);
    infoEl?.classList.add("error");
    infoEl!.innerHTML = message;
  };

  const setErrorInputTel = (message: string, input: HTMLElement) => {
    const inputEl = input;
    inputEl.classList.add("error");

    const inputContainerEl = inputEl.parentElement?.parentElement;

    const flagContainerEl =
      inputContainerEl?.querySelector(`.flag-container-tel`);
    flagContainerEl?.classList.add("error");

    const infoEl = inputContainerEl?.querySelector(`.input-info`);
    infoEl?.classList.add("error");
    infoEl!.innerHTML = message;
  };

  const setErrorInputTextarea = (message: string, input: HTMLElement) => {
    const inputEl = input;
    inputEl.classList.add("error");

    const inputContainerEl = inputEl.parentElement;
    const infoEl = inputContainerEl?.querySelector(`.input-info`);
    infoEl?.classList.add("error");
    infoEl!.innerHTML = message;
  };

  const setErrorInputSelect = (message: string, input: HTMLElement) => {
    const inputContainerEl = input!;
    inputContainerEl.classList.add("error");

    const infoEl = inputContainerEl?.querySelector(`.input-info`);
    infoEl?.classList.add("error");
    infoEl!.innerHTML = message;
  };

  const setErrorInputBoolean = (message: string, input: HTMLElement) => {
    const informationEl =
      input.parentElement!.querySelector<HTMLElement>(".input-info");

    informationEl?.classList.add("error");
    informationEl!.innerHTML = message;
  };

  const setErrorInput = (message: string, input: HTMLElement) => {
    const inputEl = input;
    inputEl.classList.add("error");

    const inputContainerEl = inputEl.parentElement;
    const infoEl = inputContainerEl?.querySelector(`.input-info`);
    infoEl?.classList.add("error");
    infoEl!.innerHTML = message;
  };

  const setErrorInputRate = (message: string, input: HTMLElement) => {
    const inputEl = input;
    inputEl.classList.add("error");

    const infoEl = inputEl.querySelector(`.input-info`);
    infoEl?.classList.add("error");
    infoEl!.innerHTML = message;
  };

  const setErrorInputAudioRecorder = (message: string, input: HTMLElement) => {
    const inputEl = input;
    inputEl.classList.add("error");

    const infoEl = inputEl.querySelector(`.input-info`);
    infoEl?.classList.add("error");
    infoEl!.innerHTML = message;
  };

  const setErrorInputFileUpload = (message: string, input: HTMLElement) => {
    const inputEl = input;
    inputEl.classList.add("error");

    const infoEl = inputEl.querySelector(`.input-info.files`);
    infoEl?.classList.add("error");
    infoEl!.innerHTML = message;
  };

  const setErrorInputRichText = (message: string, input: HTMLElement) => {
    const richTextEditorContainerEl =
      input.parentElement?.parentElement?.parentElement?.parentElement
        ?.parentElement;

    const infoEl = richTextEditorContainerEl?.querySelector(`.input-info`);
    infoEl?.classList.add("error");
    infoEl!.innerHTML = message;
  };

  const setError = (error: IErrors, input: HTMLElement) => {
    const {
      dataset: { input: inputType },
    } = input;

    if (!inputType) return;

    const setError = {
      password: setErrorInputPassword,
      date: setErrorInputDate,
      checkbox: setErrorInputCheckbox,
      search: setErrorInputSearch,
      tel: setErrorInputTel,
      textarea: setErrorInputTextarea,
      select: setErrorInputSelect,
      boolean: setErrorInputBoolean,
      input: setErrorInput,
      rate: setErrorInputRate,
      audioRecorder: setErrorInputAudioRecorder,
      fileUpload: setErrorInputFileUpload,
      "rich-text": setErrorInputRichText,
    };

    setError[inputType](errorsConfig[error], input);
  };

  const validateInputs = (formEl: Element) => {
    let response: boolean = true;

    const inputs = formEl.querySelectorAll<HTMLElement>("[data-input]");

    inputs.forEach((input) => {
      const {
        dataset: { status },
      } = input;

      if (status !== "VALIDATED") {
        response = false;

        setError(status as IErrors, input);
      }
    });

    return response;
  };

  const validate = () => {
    const formEl: Element = formRef.current!;

    return validateInputs(formEl);
  };

  const handlerOnSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();

    if (!noValidate && !validate()) {
      return;
    }

    onSubmit && onSubmit(event);
  };

  return (
    <FormStyled
      onSubmit={handlerOnSubmit}
      ref={formRef}
      {...props}
      autoComplete="off"
    >
      {children}
    </FormStyled>
  );
};
